import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCloudDownload = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	width: 20,
	height: 20,
	strokeWidth: 1.5,
	"data-darkreader-inline-stroke": "",
	style: { "--darkreader-inline-stroke": "currentColor" },
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", { d: "M19 18a3.5 3.5 0 0 0 0 -7h-1a5 4.5 0 0 0 -11 -2a4.6 4.4 0 0 0 -2.1 8.4" }),
		/* @__PURE__ */ _jsx("path", { d: "M12 13l0 9" }),
		/* @__PURE__ */ _jsx("path", { d: "M9 19l3 3l3 -3" })
	]
});
const ForwardRef = forwardRef(SvgCloudDownload);
export default ForwardRef;
